module.exports = __webpack_public_path__ + "static/media/38.90aa56e3.jpg";